<template>
  <master-layout>
    <!-- Breadcamb -->
    <div class="breadcamb_box">
      <div>
        <h4 class="page-title m-b-0">
          <i class="ti-plug"></i> {{ $t("integrations") }}
        </h4>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'integrations.index' }">{{
              $t("integrations")
            }}</router-link>
          </li>
          <li class="active">Facebook Leads</li>
        </ol>
      </div>
      <pml-back-button></pml-back-button>
    </div>

    <!-- Infos Integration -->
    <div class="card-box icon_integration">
      <div class="bar-widget m-b-15">
        <div class="table-box">
          <div class="table-detail w_60">
            <div class="iconbox">
              <i class="fa fa-facebook"></i>
            </div>
          </div>
          <div class="table-detail">
            <h5 class="m-t-0 m-b-5 d_inline_b">
              <b>{{ $t("_integrations.name_facebook-leads") }}</b>
            </h5>
            <p class="m-b-5 text-muted">
              {{ $t("_integrations.description_facebook-leads") }}
            </p>
          </div>
        </div>
      </div>
      <p>{{ $t("_integrations.facebook_leads.line_01") }}:</p>
      <ul>
        <li>{{ $t("_integrations.facebook_leads.line_02") }}</li>
        <li>{{ $t("_integrations.facebook_leads.line_03") }}</li>
      </ul>
      <div class="alert alert_default">
        <strong>{{ $t("attention") }}! </strong>
        {{ $t("_integrations.facebook_leads.line_04") }}.<br />
        {{ $t("_integrations.facebook_leads.line_05") }}
        <a href="/incoming" target="_blank" class="bold">{{
          $t("_integrations.facebook_leads.line_06")
        }}</a>
        {{ $t("_integrations.facebook_leads.line_07") }}.
      </div>
      <!-- <a href="http://blog.pumpmylead.com/" target="_blank" class="btn btn-purple"><span class="btn-label"><i class="fa fa-question-circle"></i></span>{{ $t('access_tutorial') }}</a> -->
      <hr />
      <div class="clearfix t_right" v-if="showFbLogin">
        <button @click="login(afterLogin)" class="btn btn-facebook">
          <span class="btn-label"><i class="fa fa-facebook"></i></span
          >{{ $t("continue_with_facebook") }}
        </button>
      </div>
      <div class="clearfix t_right" v-if="showFbLogout">
        <span v-if="showFbLogout" class="m-r-15"
          >{{ $t("you_re_logged_as") }} {{ user.name }}</span
        >
        <button
          v-if="showFbLogout"
          @click="logout(backToIndex)"
          class="btn btn-facebook"
        >
          <i class="fa fa-facebook m-r-5"></i> {{ $t("logout") }}
        </button>

        <router-link
          v-if="this.$route.name === 'integrations.facebook-leads.index'"
          :to="{ name: 'integrations.facebook-leads.create' }"
          class="btn btn-default m-l-15"
          ><span class="btn-label"><i class="fa fa-plus-circle"></i></span
          >{{ $t("integration") }}</router-link
        >
      </div>
    </div>

    <!-- Form Integration -->
    <router-view @saved="saved"></router-view>

    <!-- List Integration -->
    <div class="bg_load_null min_h_98" v-pml-block="isLoading">
      <PmlItem
        v-for="item in list"
        :key="item.id"
        :item="item"
        @deleted="destroy"
      ></PmlItem>
      <div v-show="!list.length">
        <p class="t_center m-t-30">
          <i class="fa fa-exclamation-triangle"></i>
          {{ $t("no_records_found") }}
        </p>
      </div>
    </div>
  </master-layout>
</template>

<script>
import PmlItem from './Item.vue'
import Notify from '@/utils/helpers/notify'
import TableFilters from '@/utils/mixins/table-filters'
import { trans } from '@/utils/helpers/translation'
import { getAllFacebookLeads } from '@/services/integrations'
import { init, login, logout, getName, getStatus } from '@/services/facebook'
import { removeById } from '@/utils/helpers/arrays'
import { isNil, find } from 'lodash'
import { mapGetters } from 'vuex'
import bus from '@/utils/events/bus'

export default {
    name: 'FacebookLeads',
    mixins: [TableFilters],
    components: { PmlItem },
    data () {
        return {
            records: [],
            isRefreshing: false,
            isLoading: false,
            isFbLogged: false,
            isFbSet: false,
            listConfig: {
                orderProp: 'created_at',
                orderDir: 'asc',
                columns: ['created_at']
            },
            user: {
                id: null,
                accessToken: null,
                name: null
            }
        }
    },
    metaInfo () {
        return {
            title: trans('integrations') + ' | Facebook Leads'
        }
    },
    created () {
        init(this.afterInit)
        this.handleRoute(this.$route)
    },
    computed: {
        ...mapGetters({
            'tenant': 'getTenant'
        }),
        showFbLogin () {
            return this.$route.name === 'integrations.facebook-leads.index' && this.isFbSet && !this.isFbLogged
        },
        showFbLogout () {
            return this.isFbSet && this.isFbLogged
        }
    },
    watch: {
        '$route' (val) {
            this.handleRoute(val)
        }
    },
    mounted () {
        if (!['premium_power_sales'].includes(this.tenant.stripePlan))
            this.$router.push({ name: 'error.404' })

        this.refresh()
    },
    methods: {
        afterInit () {
            this.isFbSet = true
        },
        handleRoute (route) {
            if (route.name === 'integrations.facebook-leads.index')
                this.$nextTick(() => { init(this.afterInit) })

            if (route.name === 'integrations.facebook-leads.create' && !this.isFbLogged)
                this.$nextTick(() => { this.backToIndex() })

            if (route.name === 'integrations.facebook-leads.create' && this.isFbLogged)
                this.$nextTick(() => { bus.$emit('setUser', this.user) })
        },
        refresh () {
            this.isLoading = true
            getStatus(this.afterLogin)
            getAllFacebookLeads()
        .then(response => { this.records = response.data })
        .catch(() => { Notify.error(trans('_notifications.error')) })
        .then(() => { this.isLoading = false })
        },
        login: (callback) => login(callback),
        afterLogin (response) {
            if (response.status === 'connected') {
                this.user.id = response.authResponse.userID
                this.user.accessToken = response.authResponse.accessToken
                this.isFbLogged = true
                this.$router.push({ name: 'integrations.facebook-leads.create' })
                getName(this.user.id, this.setName)
            }
        },
        setName (response) {
            if (response && !response.error)
                this.user.name = response.name
        },
        logout: (callback) => logout(callback),
        backToIndex () {
            this.clear()
            this.$router.push({ name: 'integrations.facebook-leads.index' })
        },
        clear () {
            this.user.id = null
            this.user.accessToken = null
            this.user.name = null
            this.isFbLogged = false
        },
        destroy (id) {
            removeById(this.records, id)
        },
        saved (item) {
            if (!isNil(find(this.records, { id: item.id })))
                removeById(this.records, item.id)

            this.records.push(item)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/providers/facebook_leads/Main.vue